import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspace/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$workspace/geographic", params: { workspace: params.workspace } });
  },
  component: () => null,
});
